<template>
  <div class="sidebar">
    <el-menu class="bg-light-gray" :router="true">
      <el-submenu index="1" class="user-submenu">
        <template slot="title">
          <div class="user">
            <figure>
            </figure>
            <p class="username text-light-blue">{{ auth.name }}</p>
            <p class="role" v-if="auth.roles && auth.roles.length > 0">
              {{ auth.roles[0].display_name }}
            </p>
          </div>
        </template>
        <el-menu-item index="/account">
          <i class="icon icon-cog"></i>
          Configuraci&oacute;n de la Cuenta
        </el-menu-item>
        <el-menu-item v-on:click="logOut()" index="2"><i class="icon icon-lock"></i>Cerrar Sesion</el-menu-item>
      </el-submenu>
    </el-menu>

    <el-menu style="margin-top: 20px" :router="true" :default-active="routePath" :default-openeds="activeSubmenu">
      <template v-for="item in menu">
        <el-menu-item-group v-if="item.type === 'group'" :index="item.index" :title="item.title">
          <template v-for="children in item.children">
            <el-menu-item v-if="children.type === 'item'" :index="children.url">
              <i v-if="children.icon" :class="children.icon"></i>
              {{ children.title }}
            </el-menu-item>

            <el-submenu v-if="children.type === 'submenu'">
              <template slot="title">
                <i v-if="children.icon" :class="children.icon"></i>
                <span slot="title">{{ children.title }}</span>
              </template>
              <div v-for="page in children.children">
                <el-menu-item v-if="page.type === 'item'" :index="page.url">
                  <i v-if="page.icon" :class="page.icon"></i>
                  {{ children.title }}
                </el-menu-item>
              </div>
            </el-submenu>
          </template>
        </el-menu-item-group>
        <el-menu-item v-if="item.type === 'item'" :index="item.url">
          <i v-if="item.icon" :class="item.icon"></i>
          {{ item.title }}
        </el-menu-item>
        <el-submenu v-if="item.type === 'submenu'" :index="item.index">
          <template slot="title">
            <i v-if="item.icon" :class="item.icon"></i>
            <span slot="title">{{ item.title }}</span>
          </template>
          <template v-for="children in item.children">
            <el-menu-item v-if="children.type === 'item'" :index="children.url">
              <i v-if="children.icon" :class="children.icon"></i>
              {{ children.title }}
            </el-menu-item>
          </template>
        </el-submenu>
      </template>
    </el-menu>
  </div>
</template>
<script>
  export default {
    name: 'sidebar',
    data () {
      return {
        menus: [
          {
            type: 'submenu',
            index: '1',
            title: 'ADMINISTRACIÓN',
            children: [
              {
                type: 'item',
                title: 'Empresas',
                icon: 'icon icon-shop',
                url: '/companies',
                permission: 'companies_s'
              },
              {
                type: 'item',
                title: 'Centro de Costos',
                icon: 'icon icon-inbox',
                url: '/cost-centers',
                permission: 'cost_centers_s'
              },
              {
                type: 'item',
                title: 'Planillas',
                icon: 'icon icon-note',
                url: '/payrolls',
                permission: 'payrolls_s'
              },
              {
                type: 'item',
                title: 'Colaboradores',
                icon: 'icon icon-heart',
                url: '/employees',
                permission: 'employees_s'
              },
              {
                type: 'item',
                title: 'No recontratables',
                icon: 'icon el-icon-circle-close',
                url: '/blacklist',
                permission: 'blacklist_s'
              },
              {
                type: 'item',
                title: 'Roles',
                icon: 'icon icon-lock',
                url: '/roles',
                permission: 'roles_s'
              },
              {
                type: 'item',
                title: 'Usuarios',
                icon: 'icon icon-user',
                url: '/users',
                permission: 'users_s'
              },
              {
                type: 'item',
                title: 'Asistencia',
                icon: 'icon icon-calendar',
                url: '/checkin',
                permission: 'checkin_s'
              }
            ]
          },
          {
            type: 'submenu',
            index: '100',
            title: 'CONFIGURACIÓN',
            children: [
              {
                type: 'item',
                title: 'Estados Civiles',
                icon: 'icon icon-heart',
                url: '/civilstatus',
                permission: 'civil_statuses_s'
              },
              {
                type: 'item',
                title: 'Extras de Herramienta de trabajo',
                icon: 'icon icon-note',
                url: '/transportextras',
                permission: 'transport_extras_s'
              },
              {
                type: 'item',
                title: 'Niveles de Incidencias',
                icon: 'icon icon-note',
                url: '/levels',
                permission: 'incident_levels_s'
              },
              {
                type: 'item',
                title: 'Deducibles Variables',
                icon: 'icon icon-note',
                url: '/deductibletypes',
                permission: 'deductible_types_s'
              },
              {
                type: 'item',
                title: 'Deducibles',
                icon: 'icon icon-wallet',
                url: '/deductibles',
                permission: 'deductibles_s'
              },
              {
                type: 'item',
                title: 'Provisiones',
                icon: 'icon icon-wallet',
                url: '/provisions',
                permission: 'provisions_s'
              },
              {
                type: 'item',
                title: 'Posiciones Laborales',
                icon: 'icon icon-tag',
                url: '/positions',
                permission: 'positions_s'
              },
              {
                type: 'item',
                title: 'Plantillas',
                icon: 'icon fa fa-file-pdf-o',
                url: '/templates',
                permission: 'templates_s'
              }
            ]
          },
          {
            type: 'submenu',
            index: '101',
            title: 'CONFIRMACIÓN DE NOMINA',
            children: [
              {
                type: 'item',
                title: 'Confirmación de Asistencia',
                icon: 'icon el-icon-folder-checked',
                url: '/checkin/approval',
                permission: 'checkin_approval'
              },
              {
                type: 'item',
                title: 'Nómina',
                icon: 'icon icon-money',
                url: '/report',
                permission: 'payrolls_s'
              },
              {
                type: 'item',
                title: 'Herramienta de Trabajo',
                icon: 'icon icon-money',
                url: '/transportreports',
                permission: 'transport_s'
              },
              {
                type: 'item',
                title: 'Reporte de Nómina',
                icon: 'icon icon-money',
                url: '/liquidation-report',
                permission: 'payroll_report_s'
              }
            ]
          },
          {
            type: 'group',
            index: '2',
            title: 'PARAMETRIZACIONES',
            children: [
              {
                type: 'item',
                title: 'Aumento Salarial',
                icon: 'icon icon-money',
                url: '/salary-increase',
                permission: 'salary_increase_s'
              },
              {
                type: 'item',
                title: 'Reporte de Asistencia',
                icon: 'icon icon-calendar',
                url: '/checkin-report',
                permission: 'checkin_s'
              },
              {
                type: 'item',
                title: 'Aguinaldos',
                icon: 'icon icon-money',
                url: '/bonuses',
                permission: 'bonuses_s'
              },
              {
                type: 'item',
                title: 'Cesantías',
                icon: 'icon icon-money',
                url: '/severance',
                permission: 'severance_s'
              },
              {
                type: 'item',
                title: 'Reporte de Herramienta de Trabajo',
                icon: 'icon icon-money',
                url: '/transport-report',
                permission: 'transport_report_s'
              },
              {
                type: 'item',
                title: 'Reporte de Aguinaldos',
                icon: 'icon icon-money',
                url: '/bonuses-report',
                permission: 'bonuses_s'
              },
              {
                type: 'item',
                title: 'Reporte de Aumentos Salariales',
                icon: 'icon icon-money',
                url: '/salary-increase-report',
                permission: 'salary_increase_s'
              },
              {
                type: 'item',
                title: 'Reporte de Vacaciones',
                icon: 'icon icon-calendar',
                url: '/vacations-report',
                permission: 'vacations_report_s'
              }
            ]
          }
        ],
        routePath: this.$route.path,
        activeSubmenu: []
      }
    },
    computed: {
      auth () {
        return this.$store.state.auth
      },
      permissions () {
        return this.$store.state.permissions
      },
      menu () {
        return this.menus.map(item => {
          return {...item}
        }).filter((menu) => {
          let flag = false
          if (menu.type === 'submenu' || menu.type === 'group') {
            menu.children = menu.children.filter((children) => {
              return !children.permission || this.hasPermission(children.permission)
            })

            flag = (menu.children.length > 0)
          }

          return (!menu.permission && menu.type === 'item') || this.hasPermission(menu.permission) || flag
        })
      }
    },
    methods: {
      hasPermission (permission) {
        return this.permissions.some((item) => item === permission) || this.$auth.hasAllPermissions()
      },
      handleClick (e) {
        e.preventDefault()
        e.target.parentElement.classList.toggle('open')
      },
      logOut () {
        this.$auth.destroyToken()
        this.$store.state.auth = {}
        this.$router.push('/login')
      },
      goToAccount () {
        this.$router.push('/account')
      }
    },
    mounted () {
      this.activeSubmenu = this.menu.filter((item) => {
        return item.type === 'submenu' &&
          item.children &&
          item.children.some((children) => children.url === this.routePath)
      }).map((item) => item.index)
    }
  }
</script>

<style lang="css">
  .nav-link {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue